/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_5k_CreditsInputs */

const en_landing_pricing_feature_5k_credits = /** @type {(inputs: Landing_Pricing_Feature_5k_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5,000 credits`)
};

const zh_landing_pricing_feature_5k_credits = /** @type {(inputs: Landing_Pricing_Feature_5k_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5,000 积分`)
};

/**
* | output |
* | --- |
* | "5,000 credits" |
*
* @param {Landing_Pricing_Feature_5k_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_5k_credits = /** @type {((inputs?: Landing_Pricing_Feature_5k_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_5k_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_5k_credits(inputs)
	return zh_landing_pricing_feature_5k_credits(inputs)
});
export { landing_pricing_feature_5k_credits as "landing.pricing.feature_5k_credits" }